<template>
    <section class="section home">
        <div class="light">
            <img src="@/assets/img/decals/light.svg" alt="">
        </div>
        <div class="home-header">
            <div class="home-header-col">
                <p class="home__subtitle">Сегодня {{ current_day }}, {{ current_date }}</p>
            </div>
        </div>
        <div class="home-body">
            <div class="col-2">
                <dashboardChart />
            </div>
            <div :class="getUserPermissions && getUserPermissions.includes('goals_show') ? 'col-2' : 'col-4'" >
                <dashboardReviews :class="getUserPermissions && getUserPermissions.includes('goals_show') ? 'sm' : ''"/>
            </div>
            <div class="col-1">
                <dashboardNews />
            </div>
        </div>
    </section>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import dashboardReviews from "@/components/dashboard/dashboardReviews.vue"
import dashboardNews from "@/components/dashboard/dashboardNews.vue"
import dashboardChart from "@/components/dashboard/dashboardChart.vue"

export default {
    name: "HomeView",

    data() {
        return {
            task_select: "неделя",
            current_date: "",
            current_day: "",
            current_time: "",
            user_search: ''
        };
    },

    components: {
        dashboardReviews,
        dashboardNews,
        dashboardChart
    },

    computed: {
        ...mapState({
            notifications: (state) => state.home.notifications,
            user_permissions: (state) => state.user_permissions,
        }),

        ...mapGetters({
            getUserPermissions: 'getUserPermissions'
        })
    },

    methods: {
        ...mapActions({
            getShop: "home/getShop",
        }),

        getCurrentDate() {
            let date = new Date();
            let monthNames = [
                "января",
                "февраля",
                "марта",
                "апреля",
                "мая",
                "июня",
                "июля",
                "августа",
                "сентября",
                "октября",
                "ноября",
                "декабря",
            ];
            let dayNames = ["воскресенье", "понедельник", "вторник", "среда", "четверг", "пятница", "суббота"];
            let day = date.getUTCDate();
            let month = monthNames[date.getUTCMonth()];
            let year = date.getUTCFullYear();

            this.current_date = day + " " + month + " " + year;
            this.current_day = dayNames[new Date().getDay()];
        },
    },

    mounted() {
        this.getCurrentDate()
    },
};
</script>
<style scoped lang="sass">
.col-1
    min-width: 0
    @media only screen and  (max-width: 1024px)
        grid-column: 1 / 1
.col-2
    width: unset
.col-4
    grid-column: 1 / -1
    width: unset

.window-users
    & .window-header
        position: relative
    &__search
        margin-left: auto
        width: 200px
        height: 28px
        border: none
        &_icon
            position: absolute
            top: 50%
            right: 26px
            transform: translateY(-40%)
    &-table
        display: flex
        flex-direction: column
        align-items: flex-start
        &-item
            display: grid
            grid-template-columns: 50% 25% 25%
            align-items: center
            width: 100%
            &_header
                color: #808F9F
            &:nth-child(even)
                background: #FAFAFA
            & .col
                padding: 0 18px
                display: flex
                align-items: center
                height: 50px
                overflow-x: hidden 
                &:not(:last-child)
                    border-right: 1px dotted #D8D8D8
                &.link
                    font-weight: 600
                    color: var(--color-blue)
                &.roles
                    & p
                        white-space: nowrap
                        &:last-child span
                            display: none

.light
    position: absolute
    top: -80px
    right: 100px
    display: flex
    z-index: -1
    @media only screen and (max-width: 1024px)
        top: -60px
        right: -200px
    @media only screen and (max-width: 425px)
        top: -55px
        right: -400px
    & img
        @media only screen and (max-width: 1024px)
            width: 80%
        @media only screen and (max-width: 425px)
            width: 70%
    &.new_year
        top: 0
        z-index: 0
</style>
